import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '../../../../../../../../components';
import { InteractiveButton } from '../../../../../../components';
import iconError from '../../../../../../../../../assets/illustrations/error-files.svg';

interface ErrorMessageProps {
  handleClick: () => void;
  title: string;
  message: string;
  showIcon?: boolean;
}
const ErrorMessage: React.FC<ErrorMessageProps> = (props) => {
  const { handleClick, title, message, showIcon } = props;
  return (
    <>
      <Block
        customized
        maxWidth={isMobile ? '100%' : '496px'}
        backgroundColor="#fff"
        padding="0px 32px 32px 32px"
        margin="8px 0px 0px 0px"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {showIcon && (
          <Block
            customized
            display="flex"
            justifyContent="center"
            alignItems="center"
            margin="0px 0px 16px"
          >
            <img src={iconError} alt="error" />
          </Block>
        )}
        <Heading
          text={title}
          level={2}
          color="#161D1F"
          size={20}
          lineHeight={32}
          fontWeight="900"
          className=""
          align="center"
          width="100%"
        />
        {message && (
          <Block
            customized
            margin="16px 0px 0px 0px"
            justifyContent="center"
            alignItems="center"
          >
            <Text
              textAlign="center"
              fontWeight="400"
              fontSize="14px"
              lineHeight="20px"
            >
              {message}
            </Text>
          </Block>
        )}
        <InteractiveButton
          bkgColorEnabled="#5B36F2"
          bkgColorHover="#745EF6"
          bkgColorFocus="#4318CD"
          bkgColorPressed="#4318CD"
          customized
          as="button"
          alignItems="center"
          backgroundColor="#5B36F2"
          padding="10px 16px"
          borderRadius="4px"
          margin="40px 0px 0px 0px"
          width={isMobile ? '100%' : '97px'}
          onClick={() => handleClick()}
        >
          <Text
            color="#FFFFFF"
            fontSize="14px"
            lineHeight="20px"
            fontWeight="700"
            textAlign="center"
          >
            Entendido
          </Text>
        </InteractiveButton>
      </Block>
    </>
  );
};

ErrorMessage.defaultProps = {
  showIcon: false
};
export default ErrorMessage;
